import React, { useEffect, useState } from "react"
import { NavItem, NavLink } from 'reactstrap'
import MenuItemsList, { SettingsMenu } from "./Menu"
import { HomeMenuList } from "./Menu";
import { PracticeID, logIn, UserLogout } from "../../actions/LoginAction";
import { useDispatch, useSelector } from "react-redux";
import { MainTabContentActiveTab, MainTabContentTabList } from "../../actions/SidebarAction"
// import Claims from "../Billing/Claims/Claims";
import { useNavigate } from "react-router-dom";
import NotificationHandler from "../../utils/NotificationHandler";
import { enumUtil } from "../../utils/Enum";
import Loader from "../shared/Loader/Loader";
import { ServerRequestProtected, ServerRequestPublic } from "../../utils/ServerDataRequest";
import store from "../../store";
import isNull from "../../utils/NullChecking";
import Dashboard from "../Dashboard/Dashboard";
import { Modal } from "react-bootstrap";
import SearchHeader from "../Setup/Shared/SearchHeader";
import Wizard from "../Wizard/Wizard";
import ModalHeader from "../Setup/Shared/ModalHeader";
import ContentReceiver from "./ContentReceiverNewBrowserTab/ContentReceiver";
import { isChildWindow } from "../../utils/Constants";
import { IconBlinkers } from "../shared/IconsComponent/icons";
import { removeSignalRConnection } from "../../actions/SignalRhubs";
import Cookies from "js-cookie";
import { IsUserProvider } from "../../actions/IsUserProvider";
import { set } from 'lodash';
const SideBar = () => {
    let token = store.getState();
    token = token.Login.token
    const API_URL = enumUtil.controller.Login
    const API_URL_Wasabi = enumUtil.controller.Wasabi

    const count = useSelector(state => ({
        Patient: state.Open_Patient_Tab.length !== 0 ? state.Open_Patient_Tab.length - 1 : state.Open_Patient_Tab.length,
        Caregiver: state.Open_Caregiver_Tab.length,
        Encounters: state.Open_EncounterMenu_Tab.length !== 0 ? state.Open_EncounterMenu_Tab.length - 1 : state.Open_EncounterMenu_Tab.length,
        Claims: state.Open_Claim_Tab.length !== 0 ? state.Open_Claim_Tab.length - 1 : state.Open_Claim_Tab.length,
        Payments: state.Open_Payment_Tab.length !== 0 ? state.Open_Payment_Tab.length - 1 : state.Open_Payment_Tab.length,
        Reports: state.Open_Report_Tab.length,
        Task: state.GeneralDropDownsReducer?.TaskCount,
        Support: state.GeneralDropDownsReducer?.SupportTicketCount,
    }));
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    let Blinker = useSelector(state => state.BlinkerReducer)

    const [openSub, setOpenSub] = useState({})
    let stateActive = useSelector(state => state.SidebarActiveTab)
    let sideBarList = useSelector(state => state.SidebarList)
    const dispatch = useDispatch();
    const MenuItems = MenuItemsList()
    const SettingItems = SettingsMenu();
    const [activeTab, setActiveTab] = useState()
    // const [tabList, setTabsList] = useState([])
    const [activeColor, setActiveColor] = useState({ background: "#3498DB" })
    const [activeColorutilities, setActivesColorUntilities] = useState({ background: "#FF0000" })
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [gender, setGender] = useState('')

    const handleOpenSubTab = (name) => {

        setOpenSub((prev) => ({ ...prev, [name]: !prev[name] }))
    }

    const [userDetail, setUserDetail] = useState({
        RoleName: '',
        Name: '',
        Picture: ''
    })


    const [mainpicmodel, setMainpicmodel] = useState();
    const [userID, setuserID] = useState()


    const handleActiveTab = (key, name, component, right, time) => {
        // console.log(right);
        if (!right) {
            return
        } else {
            let dynamicTabs = [...sideBarList]
            const newTabObject = {
                key: key,
                name: name,
                component: component,
                right: right,
                time: time,
            }
            const isTabExist = dynamicTabs.filter((tab) => {
                return tab.name === name
            })
            if (!(isTabExist && isTabExist.length > 0)) {
                dynamicTabs = [...dynamicTabs, newTabObject];
                // setTabsList(dynamicTabs)
                dispatch(MainTabContentTabList(dynamicTabs));
            }
            if (isTabExist && isTabExist.length > 0) {
                const isTabExistTime = dynamicTabs.filter((tab) => {
                    if (tab.name === name) {
                        tab.time = new Date()
                        return tab
                    }
                    return tab
                })
                // setTabsList(isTabExistTime)
                dispatch(MainTabContentTabList(isTabExistTime));
            }
            if (activeTab !== key) {
                setActiveTab(key)
            }
            dispatch(MainTabContentActiveTab(key))
        }

    }

    function toggleSidebar() {
        var getScreenWidth = window.innerWidth
        // console.log("toggleSidebar")
        if (getScreenWidth > 992) {
            document.body.classList.toggle("sidebar-slim")
        }
        if (getScreenWidth > 600 && getScreenWidth < 992) {
            if (document.body.classList.contains("tablet")) {
                document.body.classList.toggle("sidebar-slim")
            }
        }
        if (getScreenWidth < 600) {
            if (document.body.classList.contains("mobile")) {
                document.body.classList.toggle("sidebar-mobile-open")
            }
        }
        setOpenSub(() => ({}))
    }

    const openSubMenuSetting = event => {
        event.currentTarget.parentElement.classList.toggle('open');
    }
    const handleLogout = () => {
        ServerRequestProtected(API_URL + "/Logout", 'post', {})
            .then((response) => {
                dispatch(removeSignalRConnection('NotificationsHub'));
                navigate("../", { replace: true })
                NotificationHandler("Logged Out", enumUtil.enumtoaster.success)
                Cookies.remove('cookedToken');
                
                localStorage.removeItem("themeConfig"); 
                dispatch(UserLogout());
            }).catch((error) => { })
    }
    /////////////To set Active Tab from Redux Value////////////
    const handleActiveTabOpenBillingMenu = () => {
        if (stateActive) {
            setActiveTab(stateActive)
            // commented to not open submenu on opening sub tub
            // stateActive === 71 &&  setOpenSub((prev) => ({ ...prev , Billing : true}))
        }
    }
    useEffect(() => {
        handleActiveTabOpenBillingMenu();
        setOpenSub({ ...openSub, Home: true })
        if (openSub?.Home === false) {
            setOpenSub({ ...openSub, Home: false })
        }

        document.querySelector('.layout').addEventListener('click', () => {
            if (document.body.classList.contains('sidebar-slim')) {
                document.querySelectorAll('.submenu').forEach((eve) => {
                    if (eve.classList.value.includes('open')) {
                        eve.classList.remove('open')
                        setOpenSub((prev) => ({ ...prev, Billing: false, }))
                    }
                })
            } else {
                document.querySelectorAll('.settings-submenu').forEach((eve) => {
                    if (eve.classList.value.includes('open')) {
                        eve.classList.remove('open')
                    }
                })
            }
        })
    }, [stateActive])
    let ishome = false
    let menulist = HomeMenuList()
    let menuitems = menulist.filter(item => item.right === true)
    if (menuitems.length > 0) {
        ishome = true
    }
    const LoaduserImage = async (imgURL) => {
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": imgURL.Picture,
            }, "Download");

            if (response.type === 'application/jpg') {
                const blob = response;
                const objectURL = URL.createObjectURL(blob);
                return objectURL;
            }

        } catch (error) {
            console.error("Image loading error:", error);
            return null;
        }
    };
    useEffect(() => {
        // handleActiveTab(11, 'Dashboard', <Dashboard />, true, new Date())
        if (!isNull(token) && !isChildWindow) {
            setOpenSub(() => ({}))
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindUserInfo", 'post', {
                "TableName": enumUtil.enumAPITableName.User
            }).then(async (response) => {
                setuserID(response.UserID)
                setGender(response.Gender || '')

                if (response.Picture) {
                    const imageURL = await LoaduserImage(response);
                    setMainpicmodel(imageURL || null);
                }
                // setMainpicmodel(response.Picture)
                setUserDetail(response)
                dispatch(IsUserProvider(response?.IsProvider))
                setIsLoading(false)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [token])
    useEffect(() => {
        if (menuitems.length > 0) {
            !isChildWindow && handleActiveTab(menuitems[0].key, menuitems[0].name, menuitems[0].component, menuitems[0].right, new Date());
        }
        // handleActiveTab(11, 'Dashboard', <Dashboard />, true, new Date())
    }, [ishome])



    const handleImageChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();
            reader.onloadend = () => {
                let value = reader.result.toString();
                setMainpicmodel(value)
                handleSaveUser(value)
            }
            reader.readAsDataURL(file);

        }
    }

    const handleSaveUser = (value) => {
        let User = {
            TableName: enumUtil.enumAPITableName.User,
            ID: userID + "",
            data: { Picture: value },
        }
        let UserPractices = []
        let UserLocation = []
        let UserProvider = []

        {
            let saveModal = {
                User,
                UserPractices,
                UserLocation,
                UserProvider,
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/AssignPractices", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    // console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    ///////////////////////////////////////////////////////////
    const handleCount = () => {

        let c = 0;
        if (count.Claims) { c += 1 }
        if (count.Payments) { c += 1 }
        return c;
    }
    // ////==== close sidebar submenu in case of sub browser tab ====////
    // const submenuElements = document.getElementsByClassName("submenu open");
    // for (let i = 0; i < submenuElements?.length; i++) {
    //     submenuElements[i]?.classList.remove("open");
    // }
    const handleOpenWizard = () => {
        // console.log('here');
        setAddwizard(!addwizard)
    }


    //Wizard 
    const [addwizard, setAddwizard] = useState(false);
    const addwizardHeader = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>Wizard </p>;
    };

    const WithContentReceiver = (Component) => {
        return (
            <>
                <ContentReceiver />
                {Component}
            </>
        );
    };
    const getInitials = (name) => {
        const nameArray = name.split(' ');
        if (nameArray.length >= 2) {
            return nameArray[0][0] + nameArray[1][0];
        } else if (nameArray.length === 1) {
            return nameArray[0][0];
        }
        return '';
    };

    const userInitials = getInitials(userDetail.Name);
    console.log(openSub, 'openSub');

    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            <nav className={`sidebar hk-sidebar-v1 col-md-3 col-lg-2 px-0 ${isChildWindow ? 'd-none' : ''}`}>
                <div className="sidebar-header">
                    <div className="d-flex gap-3 user-view">
                        <div className="img-container s-50 circle">
                            {mainpicmodel ? (
                                <div className="img-container s-50 circle border-2 border-white">
                                    <img src={mainpicmodel} alt="" />
                                </div>
                            ) : (
                                <>
                                    {gender === "M" || gender === "m" ? (
                                        <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male">
                                            {userInitials}
                                        </p>
                                    ) : gender === "F" || gender === "f" ? (
                                        <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-female">
                                            {userInitials}
                                        </p>
                                    ) : (
                                        <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-others">
                                            {userInitials}
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="user-info">
                            <p className="heading text-white">{userDetail.Name}</p>
                            <p className="text clr-light font-m">{userDetail.RoleName}</p>
                        </div>
                    </div>
                    <button className="toggle-sidebar" onClick={toggleSidebar}>
                        <i className="icon-right-direction"></i>
                    </button>
                </div>
                <div className="menu-list-container">
                    <ul className="menu-lists top">
                        {MenuItems && MenuItems.map((item) => {
                            return (<>
                                {item.subComponents?.length > 0 ?
                                    <li className={`submenu ${openSub[item.name] ? 'open' : ''}`} key={item.key}>
                                        <a className="submenu-top-item" onClick={() => handleOpenSubTab(item.name)}>
                                            {/* {item.name === "Home" ?  */}
                                            <i className={item.icon} alt={item.name + "icon"} />
                                            {/* <img src={item.icon} alt={item.name + "icon"} />
                                            } */}
                                            <span className="nav-text">{item.name} </span>
                                            <i className={'angle-right-bottom bi bi-arrow-right-short'} />
                                            {item.name === "Billing" ? handleCount() > 0 && <span className="count">{handleCount()}</span> : <></>}
                                            {/* <div className="dot" style={activeColorutilities}></div> */}
                                            {/* <i className="angle-right-bottom bi bi-arrow-right-short"></i> */}
                                        </a>
                                        <div className="sub-menu-list ">
                                            <ul>
                                                {item.subComponents.map((subItems) => {
                                                    return (
                                                        <React.Fragment key={subItems.key}>
                                                            {subItems.name === 'Monitoring' && subItems.right === false ? null :
                                                                <NavItem onClick={() => handleActiveTab(subItems.key, subItems.name, subItems.component, subItems.right, new Date(), subItems.Background)}>
                                                                    <NavLink href="#" className={`${activeTab === subItems.key ? "active" : ""} ${subItems.right === false ? 'sidebar-disableed' : ''}`} disabled={item.right}>
                                                                        {/* {item.name === "Billing" ? <img src={subItems.icon}></img> : subItems.icon} */}
                                                                        <i className={subItems.icon} alt={subItems.name + "icon"} />
                                                                        {subItems.name}
                                                                        {count[subItems.name] ? (<span className="count"> {count[subItems.name]}</span>) : ''}
                                                                        {subItems.name === 'Billing Items' ? Blinker?.status === 'true' ? <IconBlinkers classes={'blinker '} /> : <></> : <></>}

                                                                    </NavLink>
                                                                </NavItem>
                                                            }
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </li> :
                                    <div className={item.name === "Setup" ? 'position-relative' : ''} key={item.key}>
                                        <NavItem
                                            onClick={() => handleActiveTab(item.key, item.name, item.component, item.right, new Date())}>
                                            <NavLink href="#" className={`${activeTab === item.key ? "active" : ""} ${item.right === false ? 'sidebar-disableed' : ''}`} disabled={item.right}>

                                                {/* {count[item.name] ? (<span className="count"> {count[item.name]}</span>) : item.name === "Support" && item?.dataLength > 0 ? (<span className="count"> {item?.dataLength}</span>) : <></>} */}
                                                {/* <img src={item.icon} alt={item.name + "icon"} /> */}
                                                <i className={item.icon} alt={item.name + "icon"} />
                                                <span className="nav-text">{item.name}</span>
                                                {count[item.name] ? (<span className="count position-static"> {count[item.name]}</span>) : <></>}
                                                {/* <i className={`${item.name === "Setup" ? ' d-flex icon-Group1 justify-content-end w-100 fs-14' : ''}`}/> */}
                                                {item.name === "Support" && DropdownData.IsSupportBlinker === "true" ? <IconBlinkers classes={'blinker '} /> : null}
                                            </NavLink>
                                        </NavItem>
                                        <div className="ar_icon-Group1 ">
                                            {item.name === "Setup" ? <i className='d-flex icon-Group1 justify-content-end w-100 fs-14' onClick={() => handleOpenWizard()}></i> : null}
                                        </div>
                                    </div>
                                }
                            </>)

                        })}
                    </ul>

                    <ul className="menu-lists bottom">
                        <li className="submenu settings-submenu">
                            <a onClick={openSubMenuSetting}>
                                <i className="bi bi-gear-fill text-white"></i><span>Settings</span>
                            </a>
                            <div className="sub-menu-list">
                                <ul>
                                    <li>
                                        {SettingItems && SettingItems.map((item) => {
                                            if (item.key === 10 || item.key === 111) {
                                                return (
                                                    <React.Fragment key={item.key}>
                                                        <NavItem
                                                            onClick={() => handleActiveTab(item.key, item.name, item.component, item.right, new Date())}>
                                                            <NavLink href="#" className={activeTab === item.key ? "active" : ""} >
                                                                <i className={item.icon} alt={item.name + "icon"} />
                                                                {item.name}
                                                            </NavLink>
                                                        </NavItem>
                                                    </React.Fragment>
                                                )
                                            }
                                        })}
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li onClick={handleLogout}>
                            <NavLink href="#">
                                <i className='bi bi-box-arrow-left text-white' />
                                <span >Logout</span>
                            </NavLink>
                        </li>
                    </ul>

                    {/* <div className="za-Menu-list d-flex justify-content-between align-items-center mx-3 mt-auto mb-3">
                        <div className="d-flex flex-column row-gap-15">
                            <div className="d-flex align-items-center gap-1">
                                <div className="Profile d-flex justify-content-center align-items-center"><i className="bi bi-person-fill fs-13 text-white"></i></div>
                                <p className="text font-m fs-13 text-white">Profile</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <i className="icon-Vector15 text-white"></i><p className="text font-m fs-13 text-white">Help</p>
                            </div>
                        </div>

                        <div className="d-flex flex-column row-gap-15">
                            <div className="d-flex align-items-center gap-1">
                                <i className='bi bi-arrow-left-right fs-12' /> <p className="text font-m fs-13 text-white" >Switch Practice</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <i className='bi bi-box-arrow-left text-white' /> <p className="text font-m fs-13 text-white" >Logout</p>
                            </div>
                        </div>

                    </div> */}
                </div>
            </nav>
            <Modal show={addwizard} onHide={addwizard} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 add_wizard">
                <Modal.Body>
                    <SearchHeader masterListButton={addwizard} />
                    {/* <ModalHeader HeaderName={addwizardHeader} DeletePopup={""} isClosed={() => setAddwizard(false)} key={631} Name={'SwitchPractice'} /> */}
                    <ModalHeader HeaderName={addwizardHeader} DeletePopup={""} isClosed={() => setAddwizard(false)} key={'0001'} Name={'WizardSideBar'} />
                    <Wizard />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default SideBar